<template>
  <div>
    <dashboard-header :text="$t('ui.detailSosType')" :on-back="onGoBack" />

    <div class="d-flex align-content-center justify-content-center">
      <v-card elevation="0" :loading="loading" class="card-border-10 mx-16 w-75">
        <div class="pa-5">
          <data-detail data-colon :items="items" :headers="tableHeaders" />
        </div>

      </v-card>
    </div>

  </div>
</template>

<script>
import { API2 } from "../../api";
import DataDetail from "../base/DataDetail.vue";
import mixin from "../../mixin";
import DashboardHeader from "../component/DashboardHeader";
import { mapState } from "vuex";

export default {
  components: { DashboardHeader, DataDetail },
  mixins: [mixin],
  props: {
    openTab: {
      type: Function,
      required: true
    },
    item: {
      type: Object,
    }
  },
  data() {
    return {
      detail: null,
    };
  },
  mounted() {
    this.onTab(this.item)
  },
  computed: {
    ...mapState(['locale']),
    header() {
      if (this.item) {
        return this.item.name
      }
      return ''
    },
    tableHeaders() {
      return [
        {key: 'title', label: this.$t('base.field'), thStyle: {width: '50%'}},
        {key: 'data', label: this.$t('base.value')}
      ]
    },
    items() {
      return [
        {
          title: this.$t("sosType.name"),
          data: this.detail ? this.shortenText(this.detail.name, 30) : ''
        },
        {
          title: this.$t("sosType.color"),
          data: this.detail && this.detail.color ? this.$t(`colors.${this.detail.color}`) : '',
          imageUrl: this.detail && this.detail.color ? require(`@/assets/images/sos-type-${this.detail.color}.png`) : ''
        },
        {
          title: this.$t("ui.sosTypeNumberSchedules"),
          data: this.detail ? (this.detail.sosCaseCount || 0) : ''
        },
        {
          title: this.$t("ui.alertInterHospital"),
          data: this.detail ? (this.detail.alertInterHospital == 1 ? this.$t("base.yes") : this.$t("base.no")) : ''
        },
        {
          title: this.$t("base.createdAt"),
          data: this.detail ? this.formatDate(this.detail.createdAt) : ''
        },
        {
          title: this.$t("base.updatedAt"),
          data: this.detail ? this.formatDate(this.detail.updatedAt) : ''
        },
      ]
    },

  },
  methods: {
    onTab(item) {
      if (item) this.getData(item)
    },
    async getData(item) {
      this.detail = null
      let res = await this.get(API2.SOS_TYPE, { path: item.data.sosTypeId })
      if (res) {
        this.detail = res;
      } else {
        // No data found, show popup message and go back to list
        this.onGoBack();
      }
    },
    onGoBack() {
      this.openTab(0)
    },
    shortenText(text, maxLength) {
      return text.length > maxLength ? text.substring(0, maxLength) + "…" : text;
    },
  }
};
</script>

<style scoped>
.info {
  color: #595959;
}
</style>
